"use client";

import Image from "next/image";
import Link from "next/link";
import { Paragraph, Caption } from "../ui/typography";

import React,{useState,useEffect} from "react";



import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import LangaugeDropDown from "../navbar/components/LangaugeDropDown";

// query setup strapi

import { cmsUrl} from "@/app/config";
import useFooterData from "@/cms_data/useFooterData";
export default function Footer() {
  const [contactInfo,setContactInfo] = useState({phone:"",mail1:"",mail2:""})
  const {pageData,isLoading} = useFooterData()
 

  useEffect(()=>{
    if(pageData){
      const contactInfo = pageData?.contactInfo.split("\n").filter(item=>item.length>0)
      setContactInfo({
        phone:contactInfo[0],
        mail1:contactInfo[1],
        mail2:contactInfo[2]
      })
     
    }
  },[pageData])

  if (isLoading) {
    return (
      <footer className="w-full bg-system-obsidian animate-pulse">
        <div className="px-6 py-12 w-full mx-auto max-w-[1440px]">
          <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-16 lg:gap-2 mb-8">
            <div className="col-span-1 md:row-span-2">
              <div className="flex justify-between md:justify-start lg:justify-between">
                <div className="w-[111px] h-[24px] md:w-[155px] md:h-[34px] bg-system-graphite rounded" />
                <div className="ml-[14px] w-[100px] h-[40px] bg-system-graphite rounded" />
              </div>
              
              <div className="mt-[56px] hidden lg:flex flex-col gap-2">
                {[1, 2, 3].map((i) => (
                  <div key={i} className="h-6 bg-system-graphite rounded w-36" />
                ))}
              </div>
            </div>

            {[1, 2, 3].map((col) => (
              <div key={col} className="col-span-1 hidden md:block">
                <div className="h-6 bg-system-graphite rounded w-24 mb-4" />
                <div className="space-y-3">
                  {[1, 2, 3, 4].map((item) => (
                    <div key={item} className="h-4 bg-system-graphite rounded w-32" />
                  ))}
                </div>
              </div>
            ))}

            <div className="col-span-1 hidden lg:block">
              <div className="w-[145px] h-[39px] bg-system-graphite rounded" />
            </div>
          </div>

          <div className="block md:hidden space-y-4 pb-[30px]">
            {[1, 2, 3].map((item) => (
              <div key={item} className="h-12 bg-system-graphite rounded" />
            ))}
          </div>

          <div className="mt-8 flex justify-between">
            <div className="flex gap-2">
              {[1, 2, 3, 4].map((social) => (
                <div key={social} className="w-[30px] h-[30px] bg-system-graphite rounded" />
              ))}
            </div>
            <div className="w-48 h-4 bg-system-graphite rounded" />
          </div>
        </div>
      </footer>
    );
  }



  return (
    <footer className="w-full bg-system-obsidian">
      <div className="px-6 py-12 w-full mx-auto max-w-[1440px]">
        <div className="grid  overflow-visible  md:grid-cols-3  lg:grid-cols-5 md:grid-row-2 lg:grid-row-1  gap-16 lg:gap-2 mb-8">
          <div className="col-span-1 md:row-span-2 ">
            <div className="flex   justify-between md:justify-start lg:justify-between">
              <Image
                src={`${cmsUrl}/${pageData?.companyLogo?.url}`}
                height={34}
                width={155}
                alt={pageData?.companyLogo?.alt}
                className="w-[111px] h-[24px] sm:w-[118px] sm:h-[25px] md:w-[155px] md:h-[34px]"
              />
              <div className=" ml-[14px] bg-system-graphite py-2 px-1 rounded">
                <LangaugeDropDown variant="white" />
              </div>
            </div>
            <div className="mt-[56px] text-system-disabled hidden lg:flex flex-col">
              <Paragraph variant="light" className="wireless-Light mb-[5px]">
                <Link
                  href={`tel:${contactInfo?.phone}`}
                  className="text-system-disabled hoverunderline hoverunderline-white"
                >
                  {contactInfo?.phone}
                </Link>
              </Paragraph>
              <Paragraph variant="light" className="wireless-Light mb-[5px]">
                <Link
                  href={`mailto:${contactInfo?.mail1}`}
                  className="text-system-disabled hoverunderline hoverunderline-white"
                >
                  {contactInfo?.mail1}
                </Link>
              </Paragraph>
              <Paragraph variant="light" className="wireless-Light mb-[5px]">
                <Link
                  href={`mailto:${contactInfo?.mail2}`}
                  className="text-system-disabled hoverunderline hoverunderline-white"
                >
                  {contactInfo?.mail2}
                </Link>
              </Paragraph>
            </div>
            <div className="hidden md:flex lg:hidden flex-col text-system-disabled pt-6 pb-6">
              <Image
                src={`${cmsUrl}/${pageData?.companyLogo?.url}`}
                height={39}
                width={145}
                alt={pageData?.companyLogo?.alt}
                className=" mb-8"
              />
              <Paragraph variant="light" className="wireless-Light mb-[8px]">
                <Link
                  href={`tel:${contactInfo?.phone}`}
                  className="hoverunderline hoverunderline-white"
                >
                  {contactInfo?.phone}
                </Link>
              </Paragraph>
              <Paragraph variant="light" className=" mb-[8px]">
                <Link
                  href={`mailto:${contactInfo?.mail1}`}
                  className="hoverunderline hoverunderline-white"
                >
                  {contactInfo?.mail1}
                </Link>
              </Paragraph>
              <Paragraph variant="light" className="wireless-Light mb-[8px] ">
                <Link
                  href={`mailto:${contactInfo?.mail2}`}
                  className="hoverunderline hoverunderline-white"
                >
                  {contactInfo?.mail2}
                </Link>
              </Paragraph>
            </div>
          </div>

          <ul className="col-span-1  text-system-disabled hidden md:flex flex-col pl-0 md:pl-8 lg:pl-24">
            <Paragraph as="li" size="s" className="wireless-Regular mb-[12px] ">
              Company 
            </Paragraph>
            <>
              {pageData?.pageLinks?.map((item, index) => {
                    return (
                      <Paragraph
                        as="li"
                        variant="light"
                        className=" mb-[5px]"
                        key={index}
                      >
                        <Link
                          href={item?.link}
                         
                          className="hoverunderline hoverunderline-white"
                        >
                          {item.name}
                        </Link>
                      </Paragraph>
                    );
                  })}
            </>
          </ul>

            <ul className="col-span-1  text-system-disabled hidden md:flex flex-col pl-0 md:pl-8 lg:pl-24">
                      <Paragraph as="li" size="s" className="wireless-Regular mb-[12px] ">
                        Company 
                      </Paragraph>
                      <>
                        {pageData?.pageLinks?.map((item, index) => {
                              return (
                                <Paragraph
                                  as="li"
                                  variant="light"
                                  className=" mb-[5px]"
                                  key={index}
                                >
                                  <Link
                                    href={item?.link}
                                  
                                    className="hoverunderline hoverunderline-white"
                                  >
                                    {item.name}
                                  </Link>
                                </Paragraph>
                              );
                            })}
                      </>
                    </ul>
        

          <ul className="col-span-1 text-system-disabled hidden md:block pl-0 md:pl-8 lg:pl-24">
            <Paragraph as="li" className="wireless-Light mb-[12px] ">
             Services
            </Paragraph>
            <>
              {pageData?.serviceLinks?.map((item, index) => {
                    return (
                      <Paragraph
                        as="li"
                        variant="light"
                        className="wireless-Light mb-[5px]"
                        key={index}
                      >
                        <Link
                          href={item?.link}
                          className="hoverunderline hoverunderline-white"
                        >
                          {item.name}
                          </Link>
                      </Paragraph>
                    );
                  })}
            </>
          </ul>

          <div className="col-span-1 hidden lg:block lg:pl-24">
            <Image
              src={`${cmsUrl}/${pageData?.appleAuthorized?.url}`}
              height={39}
              width={145}
              alt={pageData?.appleAuthorized?.alt}
              className="w-[145px] h-[39px] object-contain"
            />
          </div>
        </div>

        <div className="block md:hidden text-system-disabled w-full  pb-[30px]">
          <Accordion type="single" collapsible>
            <AccordionItem value="item-1" className="border-inherit border-system-steel">
              <AccordionTrigger className="border-inherit">
                Company 
              </AccordionTrigger>
              <AccordionContent>
                {pageData?.pageLinks?.map((item, index) => {
                      return (
                        <Paragraph
                          size="s"
                          className="wireless-Light mb-[8px]"
                          key={index}
                        >
                          <Link
                            href={item?.link}
                            className="hoverunderline hoverunderline-white"
                          >
                            {item.name}
                          </Link>
                        </Paragraph>
                      );
                    })}
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-2" className="border-inherit border-system-steel">
              <AccordionTrigger>
                Services
              </AccordionTrigger>
              <AccordionContent>
                {pageData?.serviceLinks?.map((item, index) => {
                      return (
                        <Paragraph
                          size="s"
                          className="wireless-Light mb-[8px]"
                          key={index}
                        >
                          <Link
                            href={item?.link}
                            className="hoverunderline hoverunderline-white"
                          >
                            {item.name}
                          </Link>
                        </Paragraph>
                      );
                    })}
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-3" className="border-inherit border-system-steel">
              <AccordionTrigger>
                Terms & Conditions
              </AccordionTrigger>
              <AccordionContent>
                {pageData?.termsLists?.map((item, index) => {
                      return (
                        <Paragraph
                          size="s"
                          className="wireless-Light mb-[8px]"
                          key={index}
                        >
                          <Link
                            href={item?.typeUrl}
                            className="hoverunderline hoverunderline-white"
                          >
                            {item.title}
                          </Link>
                        </Paragraph>
                      );
                    })}
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>

        <div className="flex md:hidden flex-col text-system-disabled pt-6 pb-6">
          <Image
            src={`${cmsUrl}/${pageData?.appleAuthorized?.url}`}
            height={39}
            width={145}
            alt={pageData?.appleAuthorized?.alt}
            className=" mb-8"
          />
          <Paragraph size="s" className="wireless-Light mb-[8px]">
            <Link
              href={`tel:${contactInfo?.phone}`}
              className="hover:text-system-sky"
            >
              {contactInfo?.phone}
            </Link>
          </Paragraph>
          <Paragraph size="s" className="wireless-Light mb-[8px]">
            <Link
              href={`mailto:${contactInfo?.mail1}`}
              className="hover:text-system-sky"
            >
              {contactInfo?.mail1}
            </Link>
          </Paragraph>
          <Paragraph size="s" className="wireless-Light mb-[8px]">
            <Link
              href={`mailto:${contactInfo?.mail2}`}
              className="hover:text-system-sky"
            >
              {contactInfo?.mail2}
            </Link>
          </Paragraph>
        </div>

        <div className=" text-system-disabled block md:flex justify-between w-full">
          <ul className="flex gap-2 lg:justify-between ">
            {pageData?. socialLinks?.map((social, index) => {
                  return (
                    <li
                      key={index}
                      className="w-[30px] h-[30px] bg-system-graphite rounded border-0  hover:bg-midnightIndigo-500 flex items-center justify-center"
                    >
                      <Link href={social?.link} className="">
                        {" "}
                        <Image
                          src={`${cmsUrl}/${social?.icon?.url}`}
                          height={20}
                          width={20}
                          alt={social?.icon?.alt}
                          className="h-[20px] w-[20px] object-contain "
                        />
                      </Link>
                    </li>
                  );
                })}
          </ul>

          <Caption size="xs" className="text-system-titanium mt-[32px] md:mt-0">
            {pageData?.copyRight}
          </Caption>
        </div>
      </div>
    </footer>
  );
}
